/* Aanbodpagina (USA-nabouw van NL page.offer, /pages/daily-essential-aanbieding).
   Werking overgenomen uit de NL-pagina: klok in de actiebalk, verzenddatum, reserveringsteller,
   tabs, bundelkeuze, sticky productbalk, galerij, video's die spelen als ze in beeld zijn,
   reviews uitklappen en de bundel-bouwer (maat → kleur → set → checkout).
   Geen tekst in deze code: alles komt uit de secties (data-attributen en het JSON-blok van
   sections/mv-offer-bouwer.liquid). Geen NL-tracking.
   Het script staat in meerdere secties; het draait één keer en zet elk onderdeel één keer op
   (ook na een herlaad van een sectie in de theme editor). */
(function () {
  'use strict';
  if (window.mvOffer) return;
  window.mvOffer = true;

  // ── hulpjes ─────────────────────────────────────────────────────────
  function tc(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // [naam] in een tekst vervangen; de waarden zijn al veilig (escaped of eigen html).
  function vul(tekst, waarden) {
    return String(tekst || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(waarden, k) ? waarden[k] : m;
    });
  }
  function geld(centen, valuta, taal) {
    try {
      return new Intl.NumberFormat(taal || 'en', { style: 'currency', currency: valuta || 'USD' }).format(centen / 100);
    } catch (e) {
      return '$' + (centen / 100).toFixed(2);
    }
  }
  // Bundelprijs volgens de deal van het product (data.bars uit mv_bundels.deal): de grootste bar met aantal <= n,
  // prijs per stuk maal n, op centen afgerond. Zo rekent de kassa ook (usa/scripts/us-bundels.py) en zo rekent
  // snippets/mv-bundel-prijs.liquid. Tot 29 okt 2026 stond hier vast "per vijf twee gratis"; dat bleef staan toen de
  // deal een 2-Pack en 3-Pack met korting per stuk werd.
  function bundelTotaal(n, stuk, bars) {
    var bar = null;
    (bars || []).forEach(function (b) {
      if ((b.totaal != null || b.betaald != null) && b.aantal <= n && (!bar || b.aantal > bar.aantal)) bar = b;
    });
    if (!bar || !n) return n * stuk;
    var per = bar.totaal != null ? bar.totaal / bar.aantal : stuk * bar.betaald / bar.aantal;
    return Math.round(per * n);
  }
  // Hele gratis stuks (koop 2, krijg 1): alleen als de korting precies een veelvoud van de stukprijs is
  function gratisVan(n, stuk, bars) {
    if (!stuk) return 0;
    var g = (n * stuk - bundelTotaal(n, stuk, bars)) / stuk;
    return Math.abs(g - Math.round(g)) < 0.01 ? Math.round(g) : 0;
  }
  // Volgende bundel boven n die per stuk goedkoper is (voor de duwtjes in de bouwer); 0 als er geen is
  function volgendeBar(n, stuk, bars) {
    var nu = n ? bundelTotaal(n, stuk, bars) / n : stuk, doel = 0;
    (bars || []).forEach(function (b) {
      if (b.aantal > n && (!doel || b.aantal < doel) && bundelTotaal(b.aantal, stuk, bars) / b.aantal < nu - 0.5) doel = b.aantal;
    });
    return doel;
  }
  // Verzenddatum: vandaag vóór de cut-off, anders de volgende werkdag. Zegt VERZONDEN, niet geleverd.
  function verzenddatum(cutoff, taal) {
    var d = new Date();
    if (d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    try {
      return d.toLocaleDateString(taal || 'en', { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString();
    }
  }
  function eenmaal(el, sleutel) {
    if (!el || el.dataset[sleutel]) return false;
    el.dataset[sleutel] = '1';
    return true;
  }
  function speel(v) {
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // ── bovenste deel: actiebalk, tabs, bundels, galerij ────────────────
  function initHero(root) {
    if (!eenmaal(root, 'abKlaar')) return;
    var cutoff = parseInt(root.dataset.cutoff, 10) || 17;
    var taal = root.dataset.taal || 'en';
    var valuta = root.dataset.valuta || 'USD';
    var stuk = parseInt(root.dataset.stuk, 10) || 0;
    var advies = parseInt(root.dataset.advies, 10) || stuk;

    root.querySelectorAll('[data-verzend]').forEach(function (el) { el.textContent = verzenddatum(cutoff, taal); });

    // Klok: telt af naar middernacht in de tijdzone van de bezoeker en begint daarna opnieuw.
    var klok = root.querySelector('[data-ab-klok]');
    if (klok) {
      var kU = klok.querySelector('[data-u]'), kM = klok.querySelector('[data-m]'), kS = klok.querySelector('[data-s]');
      var tik = function () {
        var nu = new Date();
        var midder = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1, 0, 0, 0, 0);
        var over = Math.max(0, Math.floor((midder - nu) / 1000));
        kU.textContent = tc(Math.floor(over / 3600));
        kM.textContent = tc(Math.floor(over / 60) % 60);
        kS.textContent = tc(over % 60);
      };
      tik();
      setInterval(tik, 1000);
    }

    // De actiebalk staat vast bovenin; de sticky productbalk hangt eronder.
    var balk = root.querySelector('[data-ab-balk]');
    var meetBalk = function () {
      document.documentElement.style.setProperty('--balkh', (balk ? balk.offsetHeight : 0) + 'px');
    };
    meetBalk();
    window.addEventListener('resize', meetBalk, { passive: true });

    // Reserveringsteller: loopt één keer af en blijft daarna staan (niet resetten).
    var res = root.querySelector('[data-ab-reservering]');
    if (res) {
      var tijd = res.querySelector('[data-ab-res]');
      var over = (parseInt(res.dataset.minuten, 10) || 9) * 60;
      var teller = setInterval(function () {
        over--;
        if (tijd) tijd.textContent = tc(Math.floor(over / 60)) + ':' + tc(over % 60);
        if (over > 0) return;
        clearInterval(teller);
        res.classList.add('verlopen');
        var tekst = res.querySelector('[data-ab-res-tekst]');
        if (tekst) tekst.textContent = res.dataset.verlopen || '';
      }, 1000);
    }

    // Tabs; de klantvideo speelt alleen als zijn tab open staat.
    var tabs = root.querySelectorAll('[data-ab-tabs] [role="tab"]');
    tabs.forEach(function (knop) {
      knop.addEventListener('click', function () {
        tabs.forEach(function (b) {
          var open = b === knop;
          b.setAttribute('aria-selected', String(open));
          var vak = document.getElementById(b.getAttribute('aria-controls'));
          if (!vak) return;
          vak.hidden = !open;
          var v = vak.querySelector('video');
          if (v) { if (open) speel(v); else v.pause(); }
        });
      });
    });
    var geluid = root.querySelector('[data-ab-geluid]');
    if (geluid) {
      var kv = geluid.parentNode.querySelector('video');
      geluid.addEventListener('click', function () {
        if (!kv) return;
        kv.muted = !kv.muted;
        geluid.textContent = kv.muted ? geluid.dataset.uit : geluid.dataset.aan;
        if (kv.paused) speel(kv);
      });
      if (kv) kv.addEventListener('click', function () { if (kv.paused) speel(kv); else kv.pause(); });
    }

    // Bundelkeuze: past de prijs in de hoofdknop aan.
    var bundels = root.querySelectorAll('[data-ab-bundels] .bundel');
    var cta = root.querySelector('[data-ab-hoofdcta]');
    var oud = cta && cta.querySelector('.oud');
    var nuEl = cta && cta.querySelector('.nu');
    var kies = function (el) {
      bundels.forEach(function (b) { b.setAttribute('aria-checked', String(b === el)); });
      var n = parseInt(el.dataset.n, 10) || 1;
      var betaal = el.dataset.totaal ? parseInt(el.dataset.totaal, 10) : n * stuk;
      var waarde = n * advies;
      if (nuEl) nuEl.textContent = geld(betaal, valuta, taal);
      if (oud) { oud.textContent = geld(waarde, valuta, taal); oud.hidden = waarde <= betaal; }
    };
    bundels.forEach(function (b) {
      b.addEventListener('click', function () { kies(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); kies(b); }
      });
    });

    // Sticky productbalk zodra de hoofdknop uit beeld is.
    var pbalk = root.querySelector('[data-ab-pbalk]');
    if (pbalk && cta) {
      var BOVENZONE = 240, SPELING = 24, grens = 0;
      var meetGrens = function () { grens = cta.getBoundingClientRect().bottom + (window.scrollY || 0); };
      var verberg = function (direct) {
        if (!pbalk.classList.contains('zichtbaar')) return;
        if (!direct) { pbalk.classList.remove('zichtbaar'); return; }
        pbalk.style.transition = 'none';
        pbalk.classList.remove('zichtbaar');
        void pbalk.offsetHeight;
        pbalk.style.transition = '';
      };
      meetGrens();
      window.addEventListener('load', meetGrens);
      if (window.ResizeObserver) new ResizeObserver(meetGrens).observe(document.body);
      window.addEventListener('scroll', function () {
        var y = window.scrollY || 0;
        if (y <= BOVENZONE) { verberg(true); return; }
        if (y > grens + SPELING) pbalk.classList.add('zichtbaar');
        else if (y < grens - SPELING) verberg(false);
      }, { passive: true });
    }

    initGalerij(root.querySelector('[data-ab-galerij]'));
  }

  function initGalerij(gal) {
    if (!gal) return;
    var dias = [].slice.call(gal.querySelectorAll('[data-ab-dia]'));
    var duimen = [].slice.call(gal.querySelectorAll('[data-ab-duim]'));
    if (dias.length < 2) return;
    var nu = 0;
    function toon(i) {
      nu = (i + dias.length) % dias.length;
      dias.forEach(function (d, j) {
        var v = d.querySelector('video');
        d.hidden = j !== nu;
        if (v) { if (j === nu) speel(v); else v.pause(); }
      });
      duimen.forEach(function (t, j) { t.classList.toggle('actief', j === nu); });
    }
    duimen.forEach(function (t, i) { t.addEventListener('click', function () { toon(i); }); });
    var l = gal.querySelector('[data-ab-vorige]'), r = gal.querySelector('[data-ab-volgende]');
    if (l) l.addEventListener('click', function () { toon(nu - 1); });
    if (r) r.addEventListener('click', function () { toon(nu + 1); });
    // Vegen: alleen horizontaal reageren, verticaal is scrollen.
    var vak = gal.querySelector('.hoofdbeeld');
    var DREMPEL = 40, x0 = 0, y0 = 0, bezig = false, mx = null;
    vak.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; bezig = true;
    }, { passive: true });
    vak.addEventListener('touchend', function (e) {
      if (!bezig) return;
      bezig = false;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) < DREMPEL || Math.abs(dx) < Math.abs(dy)) return;
      toon(dx < 0 ? nu + 1 : nu - 1);
    }, { passive: true });
    vak.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') mx = e.clientX; });
    vak.addEventListener('pointerup', function (e) {
      if (mx === null) return;
      var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) >= DREMPEL) toon(dx < 0 ? nu + 1 : nu - 1);
    });
  }

  // ── video's die spelen zodra ze in beeld zijn ───────────────────────
  var kijker = ('IntersectionObserver' in window) ? new IntersectionObserver(function (rijen) {
    rijen.forEach(function (r) {
      var v = r.target;
      if (!r.isIntersecting) { v.pause(); return; }
      // preload="none" laadt niets; load() is nodig om echt te beginnen.
      if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
      var start = function () {
        if (!v.paused) return;
        var b = v.getBoundingClientRect();
        if (b.top > innerHeight || b.bottom < 0) return;
        speel(v);
      };
      if (v.readyState >= 2) { start(); return; }
      if (!v.dataset.abWacht) {
        v.dataset.abWacht = '1';
        v.addEventListener('loadeddata', start);
        v.addEventListener('canplay', start);
        setTimeout(start, 1200);
      }
    });
  }, { threshold: 0.4, rootMargin: '300px 0px' }) : null;

  function initVideos(scope) {
    scope.querySelectorAll('[data-ab-inbeeld] video').forEach(function (v) {
      if (!eenmaal(v, 'abKijk')) return;
      if (kijker) kijker.observe(v);
    });
    // iOS negeert loop soms na een herlaad: zelf terugzetten als hij in beeld is.
    scope.querySelectorAll('.mv-ab video').forEach(function (v) {
      if (!eenmaal(v, 'abLoop')) return;
      v.addEventListener('ended', function () {
        var b = v.getBoundingClientRect();
        if (b.top > innerHeight || b.bottom < 0) return;
        v.currentTime = 0;
        speel(v);
      });
    });
  }

  // ── reviews ─────────────────────────────────────────────────────────
  function initReviews(root) {
    if (!eenmaal(root, 'abKlaar')) return;
    var knop = root.querySelector('[data-ab-meer]');
    if (!knop) return;
    knop.addEventListener('click', function () {
      var grid = root.querySelector('[data-ab-revgrid]');
      if (grid) grid.classList.add('open');
      knop.hidden = true;
      var op = root.querySelector('[data-ab-meer-op]');
      if (op) op.hidden = false;
    });
  }

  // ── bundel-bouwer ───────────────────────────────────────────────────
  var bouwerOpen = null;

  function initBouwer(bouwer) {
    if (!eenmaal(bouwer, 'abKlaar')) return;
    var data;
    try {
      data = JSON.parse(bouwer.querySelector('[data-ab-data]').textContent);
    } catch (e) {
      console.error('[mv-offer] bouwer-data onleesbaar', e);
      return;
    }
    var t = data.t || {};
    var q = function (sel) { return bouwer.querySelector(sel); };
    var STUK = data.stuk, ADVIES = Math.max(data.advies || 0, data.stuk);
    var eur = function (c) { return geld(c, data.valuta, data.taal); };
    var verzend = function () { return verzenddatum(data.cutoff || 17, data.taal); };

    var VAR = {}, FOTO = {};
    data.varianten.forEach(function (v) {
      (VAR[v.kleur] = VAR[v.kleur] || {})[v.maat] = v;
      if (!FOTO[v.kleur] && v.img) FOTO[v.kleur] = v.img;
    });
    var KLEUREN = data.kleuren.filter(function (k) { return VAR[k]; });
    var MATEN = data.maten;
    var BEST = (data.best || []).map(function (s) { return s.trim(); });
    var cadeau = data.cadeau;
    var cadeauVanaf = data.cadeauVanaf || 5;

    function kleurFoto(k) {
      return FOTO[k] ? '<img class="ph" src="' + esc(FOTO[k]) + '" alt="" loading="lazy" width="120" height="120">' : '';
    }
    function kanIn(k, m) { return !!(VAR[k] && VAR[k][m] && VAR[k][m].op); }

    var mand = {}, maten = {}, eigen = {}, mijnMaat = '', wijzigt = '', stap = 1;
    function aantal() { return KLEUREN.reduce(function (s, k) { return s + (mand[k] || 0); }, 0); }
    var BARS = data.bars || [];
    function teBetalen(n) { return bundelTotaal(n, STUK, BARS); }
    function gratisStuks(n) { return gratisVan(n, STUK, BARS); }
    function perStuk(n) { return n ? Math.round(teBetalen(n) / n) : STUK; }
    function besparing(n) { return n * ADVIES - teBetalen(n); }

    function vrrHtml(k) {
      var v = VAR[k][mijnMaat], drempel = data.krap || 0;
      if (!v || !drempel || !v.n || v.n > drempel) return '';
      var pct = Math.max(8, Math.min(100, Math.round(v.n / (drempel * 2) * 100)));
      return '<span class="vrr krap"><span class="tel">' + vul(esc(t.voorraad), { n: v.n }) +
        '</span><span class="baan"><i style="width:' + pct + '%"></i></span></span>';
    }

    function bouwKleuren() {
      q('[data-ab-kleuren]').innerHTML = KLEUREN.map(function (k) {
        var kan = kanIn(k, mijnMaat);
        return '<div class="kleurrij' + (kan ? '' : ' op-is') + '" data-kleur="' + esc(k) + '">' +
          (kan && BEST.indexOf(k) > -1 ? '<span class="best">' + esc(t.best) + '</span>' : '') +
          kleurFoto(k) +
          '<span class="info"><span class="knaam">' + esc(k) + '</span>' +
          (kan ? vrrHtml(k) : '<span class="weginmaat">' + vul(esc(t.uitverkochtIn), { size: esc(mijnMaat) }) + '</span>') +
          '</span>' +
          '<span class="stepper"><button type="button" data-min disabled aria-label="-">&minus;</button>' +
          '<span class="n">0</span><button type="button" class="plus" data-plus aria-label="+">+</button></span>' +
          '</div>';
      }).join('');
      q('[data-ab-maatpil]').innerHTML = vul(esc(t.maatPil), { size: '<b>' + esc(mijnMaat) + '</b>' }) + ' <u>' + esc(t.wijzigen) + '</u>';
    }

    function verzendRegel(bedrag) {
      var el = q('[data-ab-bverzend]');
      if (!el) return;
      el.innerHTML = vul(bedrag > 0 && data.gratisVanaf > 0 && bedrag >= data.gratisVanaf ? t.verzondenGratis : t.verzonden, { date: esc(verzend()) });
    }

    function gratisRegel(n) {
      var vak = q('[data-ab-gratis]');
      if (n === 0) { vak.hidden = true; return; }
      vak.hidden = false;
      var betaald = n - gratisStuks(n);
      var doel = volgendeBar(n, STUK, BARS);
      var uit = gratisStuks(n) ? '<span class="ok">' + vul(esc(t.betaalt), { n: betaald }) + '</span>' : '';
      if (doel && !gratisStuks(doel)) {
        // staffel met korting per stuk (2-Pack, 3-Pack): de prijs per stuk bij de volgende bundel
        uit += '<span class="stap">' + vul(t.stapStaffel, { n: doel - n, price: esc(eur(perStuk(doel))) }) + '</span>';
      } else if (doel) {
        uit += '<span class="stap">' + ((doel - n) === 1 ? t.stapEen
          : vul(t.stapMeer, { n: doel, k: doel - gratisStuks(doel) })) + '</span>';
      }
      vak.innerHTML = uit;
    }

    function naarStap(n) {
      stap = n;
      [1, 2, 3].forEach(function (i) { q('[data-ab-stap="' + i + '"]').hidden = i !== n; });
      q('[data-ab-totaal]').hidden = n !== 3;
      q('[data-ab-slot]').classList.toggle('weg', n !== 3);
      q('[data-ab-cta] .pijl').classList.toggle('weg', n === 3);
      q('[data-ab-titel]').textContent = n === 1 ? t.titelMaat : n === 2 ? t.titelKleur : t.titelSet;
      if (n === 1) {
        q('[data-ab-cta]').disabled = true;
        q('[data-ab-ctatekst]').textContent = t.ctaMaat;
        q('[data-ab-maatmelding]').hidden = true;
        gratisRegel(0);
        verzendRegel(0);
        tekenMaatgrid();
      }
      if (n === 2) { bouwKleuren(); tekenKleuren(); }
      if (n === 3) tekenSet();
      q('[data-ab-body]').scrollTop = 0;
    }

    function tekenKleuren() {
      bouwer.querySelectorAll('.kleurrij').forEach(function (rij) {
        var k = rij.dataset.kleur, n = mand[k] || 0;
        rij.querySelector('.n').textContent = n;
        rij.querySelector('[data-min]').disabled = n === 0;
        rij.classList.toggle('gekozen', n > 0);
      });
      var n = aantal();
      gratisRegel(n);
      verzendRegel(teBetalen(n));
      q('[data-ab-cta]').disabled = n === 0;
      q('[data-ab-ctatekst]').textContent = n === 0 ? t.ctaLeeg : vul(t.ctaVerder, { amount: eur(besparing(n)) });
    }

    function tekenMaatgrid() {
      q('[data-ab-maten]').innerHTML = MATEN.map(function (m) {
        var op = KLEUREN.some(function (k) { return kanIn(k, m); });
        return '<button type="button" aria-pressed="' + (m === mijnMaat) + '" data-maat="' + esc(m) + '"' +
          (op ? '' : ' disabled') + '>' + esc(m) + '</button>';
      }).join('');
    }

    function tekenSheetgrid() {
      var kleur = wijzigt.split('#')[0], nu = maten[wijzigt];
      q('[data-ab-sheetkop]').textContent = vul(t.sheetKop, { color: kleur });
      q('[data-ab-sheetmaten]').innerHTML = MATEN.map(function (m) {
        return '<button type="button" aria-pressed="' + (m === nu) + '" data-smaat="' + esc(m) + '"' +
          (kanIn(kleur, m) ? '' : ' disabled') + '>' + esc(m) + '</button>';
      }).join('');
      var weg = MATEN.filter(function (m) { return !kanIn(kleur, m); });
      q('[data-ab-sheetnoot]').textContent = weg.length ? vul(t.sheetNoot, { color: kleur }) : '';
    }

    function tekenSet() {
      var totaal = aantal(), gratis = gratisStuks(totaal), eersteGratis = totaal - gratis;
      var regels = '', n = 0;
      KLEUREN.forEach(function (k) {
        for (var i = 0; i < (mand[k] || 0); i++) {
          var isGratis = n >= eersteGratis;
          n++;
          regels += '<div class="setregel">' + kleurFoto(k) +
            '<span class="info"><span class="knaam">' + esc(k) + '</span>' +
            '<span class="maat">' + vul(esc(t.maat), { size: esc(maten[k + '#' + i] || '-') }) + '</span><br>' +
            '<button class="wijzig" type="button" data-wijzig="' + esc(k) + '#' + i + '">' + esc(t.wijzigen) + '</button></span>' +
            (isGratis
              ? '<span class="prijs"><b class="vrij-prijs">' + esc(t.gratis) + '</b><s>' + eur(STUK) + '</s>' +
                '<span class="waarom">' + esc(gratis > 1 ? t.actie32 : t.actie21) + '</span></span>'
              : '<span class="prijs"><b>' + eur(gratis ? STUK : perStuk(totaal)) + '</b>' +
                (ADVIES > (gratis ? STUK : perStuk(totaal)) ? '<s>' + eur(ADVIES) + '</s>' : '') + '</span>') +
            '</div>';
        }
      });
      if (cadeau && n >= cadeauVanaf) {
        regels += '<div class="setregel cadeauregel">' +
          (cadeau.img ? '<img class="ph" src="' + esc(cadeau.img) + '" alt="" loading="lazy" width="120" height="120">' : '') +
          '<span class="info"><span class="knaam">' + esc(t.cadeauNaam) + '</span>' +
          '<span class="maat">' + esc(t.cadeauSub) + '</span></span>' +
          '<span class="prijs"><b class="vrij-prijs">' + esc(t.gratis) + '</b><s>' + eur(cadeau.prijs) + '</s>' +
          '<span class="waarom">' + esc(t.actie32) + '</span></span></div>';
      }
      q('[data-ab-setregels]').innerHTML = regels;
      q('[data-ab-setaantal]').textContent = n;

      var doel = volgendeBar(n, STUK, BARS);
      var nudge = q('[data-ab-nudge]');
      if (!doel) {
        nudge.hidden = true;
        q('[data-ab-bijkiezer]').hidden = true;
      } else {
        nudge.hidden = false;
        var rest = doel - n, erbij = gratisStuks(doel) - gratisStuks(n);
        q('[data-ab-nudgetekst]').innerHTML = (erbij <= 0 ? vul(t.nudgeStaffel, { n: rest, price: esc(eur(perStuk(doel))) })
          : rest === 1 ? t.nudgeEen : vul(t.nudgeMeer, { n: rest, k: erbij })) +
          (doel >= cadeauVanaf && cadeau ? t.nudgeCadeau : '');
        q('[data-ab-nudgeknop]').textContent = rest === 1 ? t.knopEen : vul(t.knopMeer, { n: rest });
      }

      var waarde = n * ADVIES, pay = teBetalen(n), besp = besparing(n);
      q('[data-ab-twaarde]').textContent = eur(waarde);
      q('[data-ab-tbesp]').textContent = eur(besp);
      q('[data-ab-tpct]').textContent = waarde > 0 ? '-' + Math.round(besp / waarde * 100) + '%' : '';
      q('[data-ab-tpay]').textContent = eur(pay);
      verzendRegel(pay);
      q('[data-ab-ctatekst]').textContent = t.ctaCheckout;
      q('[data-ab-slot]').classList.remove('weg');
      q('[data-ab-cta] .pijl').classList.add('weg');
      q('[data-ab-cta]').disabled = n === 0;
    }

    // Scroll-slot volgt de class, wat er ook gebeurt.
    function syncSlot() { document.body.style.overflow = bouwer.classList.contains('open') ? 'hidden' : ''; }
    new MutationObserver(syncSlot).observe(bouwer, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('pageshow', syncSlot);

    function open() {
      if (!mijnMaat) naarStap(1);
      bouwer.classList.add('open');
      bouwer.setAttribute('aria-hidden', 'false');
      var terug = q('[data-ab-terug]');
      if (terug) terug.focus({ preventScroll: true });
    }
    function sluit() {
      bouwer.classList.remove('open');
      bouwer.setAttribute('aria-hidden', 'true');
    }
    bouwerOpen = open;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !bouwer.classList.contains('open')) return;
      var sheet = q('[data-ab-sheet]'), gids = q('[data-ab-gidsvak]');
      if (gids.classList.contains('open')) { gids.classList.remove('open'); bouwer.classList.remove('gids-open'); }
      else if (sheet.classList.contains('open')) sheet.classList.remove('open');
      else sluit();
    });

    q('[data-ab-kleuren]').addEventListener('click', function (e) {
      var rij = e.target.closest('.kleurrij');
      if (!rij) return;
      var k = rij.dataset.kleur;
      if (!kanIn(k, mijnMaat)) return;
      if (e.target.closest('[data-plus]')) {
        maten[k + '#' + (mand[k] || 0)] = mijnMaat;
        mand[k] = (mand[k] || 0) + 1;
      }
      if (e.target.closest('[data-min]') && mand[k]) {
        mand[k] -= 1;
        delete maten[k + '#' + mand[k]];
        delete eigen[k + '#' + mand[k]];
      }
      tekenKleuren();
    });

    q('[data-ab-cta]').addEventListener('click', function () {
      if (stap === 2) { naarStap(3); return; }
      if (stap !== 3) return;
      // Vangnet: elk stuk moet een bestaande, leverbare variant hebben, anders klopt de korting niet.
      var delen = [], mist = [];
      KLEUREN.forEach(function (k) {
        for (var i = 0; i < (mand[k] || 0); i++) {
          var m = maten[k + '#' + i];
          if (m && kanIn(k, m)) delen.push(VAR[k][m].id + ':1');
          else mist.push(k);
        }
      });
      if (mist.length) {
        q('[data-ab-ctatekst]').textContent = vul(t.ctaMist, { color: mist[0] });
        return;
      }
      // Het cadeau voegt Shopify niet zelf toe: de korting maakt het pas gratis als het in de mand zit.
      if (cadeau && delen.length >= cadeauVanaf) delen.push(cadeau.id + ':1');
      if (delen.length) window.location.href = '/cart/' + delen.join(',');
    });

    function kiesMaat(m) {
      if (!m || !KLEUREN.some(function (k) { return kanIn(k, m); })) return;
      var oude = mijnMaat, eruit = [];
      mijnMaat = m;
      if (oude && oude !== m) {
        KLEUREN.forEach(function (k) {
          if (mand[k] && !kanIn(k, m)) {
            eruit.push(k);
            for (var i = 0; i < mand[k]; i++) { delete maten[k + '#' + i]; delete eigen[k + '#' + i]; }
            delete mand[k];
          }
        });
        KLEUREN.forEach(function (k) {
          for (var i = 0; i < (mand[k] || 0); i++) {
            var sl = k + '#' + i;
            if (!eigen[sl]) maten[sl] = m;
          }
        });
      }
      naarStap(2);
      var mld = q('[data-ab-maatmelding]');
      mld.hidden = !eruit.length;
      if (eruit.length) mld.textContent = vul(t.maatWeg, { color: eruit.join(' ' + t.en + ' '), size: m });
    }

    q('[data-ab-maten]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-maat]');
      if (!b || b.disabled) return;
      bouwer.querySelectorAll('[data-ab-maten] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      setTimeout(function () { kiesMaat(b.dataset.maat); }, 140);
    });

    var sheet = q('[data-ab-sheet]');
    q('[data-ab-sheetmaten]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-smaat]');
      if (!b || b.disabled) return;
      maten[wijzigt] = b.dataset.smaat;
      eigen[wijzigt] = b.dataset.smaat !== mijnMaat;
      tekenSheetgrid();
      setTimeout(function () { sheet.classList.remove('open'); tekenSet(); }, 140);
    });
    q('[data-ab-maatpil]').addEventListener('click', function () { naarStap(1); });
    bouwer.querySelectorAll('[data-ab-sheetsluit]').forEach(function (x) {
      x.addEventListener('click', function () { sheet.classList.remove('open'); });
    });

    // ── maattabel en rekenhulp ──
    var gids = q('[data-ab-gidsvak]');
    bouwer.querySelectorAll('[data-ab-gids]').forEach(function (x) {
      x.addEventListener('click', function () { gids.classList.add('open'); bouwer.classList.add('gids-open'); });
    });
    bouwer.querySelectorAll('[data-ab-gidssluit]').forEach(function (x) {
      x.addEventListener('click', function () { gids.classList.remove('open'); bouwer.classList.remove('gids-open'); });
    });
    var lijst = function (s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
    var BANDEN = lijst(data.banden), CUPS = [], TABEL = {};
    String(data.tabel || '').split(/\r?\n/).forEach(function (regel) {
      var i = regel.indexOf(':');
      if (i < 1) return;
      var cup = regel.slice(0, i).trim();
      CUPS.push(cup);
      TABEL[cup] = regel.slice(i + 1).split(',').map(function (x) { x = x.trim(); return x === '-' ? '' : x; });
    });
    var MAX = lijst(data.maxMaat);
    var gBand = q('[data-ab-gband]'), gCup = q('[data-ab-gcup]');
    BANDEN.forEach(function (b) { gBand.add(new Option(b, b)); });
    CUPS.forEach(function (c) { gCup.add(new Option(c, c)); });

    function tekenTabel() {
      var b = gBand.value, c = gCup.value;
      var kop = '<thead><tr><th>' + esc(t.gidsBand) + '</th>' + BANDEN.map(function (x) { return '<th>' + esc(x) + '</th>'; }).join('') + '</tr></thead>';
      var body = CUPS.map(function (cup) {
        return '<tr><th>' + esc(cup) + '</th>' + BANDEN.map(function (band, i) {
          var m = (TABEL[cup] || [])[i] || '';
          var raak = cup === c && band === b;
          return '<td class="' + (m ? (raak ? 'raak' : '') : 'leeg') + '">' + (m ? esc(m) : '&ndash;') + '</td>';
        }).join('') + '</tr>';
      }).join('');
      q('[data-ab-gtabel]').innerHTML = kop + '<tbody>' + body + '</tbody>';
    }
    function gidsUitslag() {
      var b = gBand.value, c = gCup.value, vak = q('[data-ab-guit]');
      if (!b || !c) {
        vak.className = 'uitslag leeg';
        vak.innerHTML = '<span class="maat">' + esc(t.gidsLeeg) + '</span>';
      } else {
        var maat = (TABEL[c] || [])[BANDEN.indexOf(b)] || '';
        if (!maat) {
          vak.className = 'uitslag leeg';
          vak.innerHTML = '<span class="maat">' + esc(t.gidsNiet) + '</span><span class="bij">' + vul(esc(t.gidsNietSub), { size: esc(b + c) }) + '</span>';
        } else if (MAX.length && MAX.indexOf(maat) === -1) {
          vak.className = 'uitslag leeg';
          vak.innerHTML = '<span class="maat">' + esc(maat) + '</span><span class="bij">' + esc(t.gidsMax) + '</span>';
        } else {
          vak.className = 'uitslag';
          vak.innerHTML = '<span class="maat">' + esc(maat) + '</span><span class="bij">' + vul(esc(t.gidsPast), { size: esc(b + c) }) +
            '</span><button class="knop" type="button" data-ab-neem="' + esc(maat) + '">' + esc(t.gidsKies) + '</button>';
        }
      }
      tekenTabel();
    }
    gBand.addEventListener('change', gidsUitslag);
    gCup.addEventListener('change', gidsUitslag);
    q('[data-ab-guit]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-ab-neem]');
      if (!b) return;
      gids.classList.remove('open');
      bouwer.classList.remove('gids-open');
      kiesMaat(b.dataset.abNeem);
    });
    tekenTabel();

    function tekenBijraster() {
      q('[data-ab-bijraster]').innerHTML = KLEUREN.map(function (k) {
        var kan = kanIn(k, mijnMaat);
        return '<button class="bijtegel" type="button" data-bij="' + esc(k) + '"' + (kan ? '' : ' disabled') + '>' +
          kleurFoto(k) + '<span>' + esc(k) + (kan ? '' : '<br>' + esc(t.uitverkocht)) + '</span></button>';
      }).join('');
    }
    q('[data-ab-nudgeknop]').addEventListener('click', function () {
      var vak = q('[data-ab-bijkiezer]');
      tekenBijraster();
      vak.hidden = false;
      vak.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    q('[data-ab-bijraster]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-bij]');
      if (!b || b.disabled) return;
      var k = b.dataset.bij;
      maten[k + '#' + (mand[k] || 0)] = mijnMaat;
      mand[k] = (mand[k] || 0) + 1;
      tekenSet();
      tekenBijraster();
    });
    q('[data-ab-setregels]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-wijzig]');
      if (!b) return;
      wijzigt = b.dataset.wijzig;
      tekenSheetgrid();
      sheet.classList.add('open');
    });
    q('[data-ab-terug]').addEventListener('click', function () {
      if (stap > 1) naarStap(stap - 1); else sluit();
    });

    naarStap(1);
  }

  // Elke knop met [data-mv-ab-open] opent de bouwer; zonder bouwer blijft het een gewone link.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mv-ab-open]');
    if (!a || !bouwerOpen) return;
    e.preventDefault();
    bouwerOpen();
  });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ab-hero]').forEach(initHero);
    scope.querySelectorAll('[data-ab-bouwer]').forEach(initBouwer);
    scope.querySelectorAll('[data-ab-reviews]').forEach(initReviews);
    initVideos(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
